export default defineAppConfig({
    ui: {
        primary: 'green',
        gray: 'cool'
    }
})
